import useDimensions from 'react-use-dimensions';

// import Links from '../Links';
import Sankey from '../Sankey';

import './styles.scss';

export default function SankeyPage(props) {
  const { data, title, description } = props;

  const [sankeyRef, { width }] = useDimensions();

  // const linkStyle = window.innerWidth <= 768 ? {
  //     marginLeft: 'calc(0.5em - 1px)',
  //     marginRight: '1.5em - 1px',
  //   } : {
  //     marginLeft: 'calc(3.5em - 1px)',
  //   };

  return data ? (
    <div className='SankeyPage'>
      {/* <Links style={linkStyle} /> */}
      <div
        ref={sankeyRef}
        className='section'
      >
        <div className='info'>
          <div className='left'>
            <h2>
              {title}
            </h2>
            {description}
          </div>
          {
            // <div className='right'>
            //   <div className='data'>
            //     <div className='heading'>
            //       <span>
            //         I want to see the budget in greater detail
            //       </span>
            //     </div>
            //     <div className='content'>
            //       <span>
            //         You can find detailed information on the budgets via the “Download the Data” button in the top right of this page. And if you still have questions, please email <a href='mailto:rmatsumoto@ravenswoodschools.org'>rmatsumoto@ravenswoodschools.org</a>
            //       </span>
            //     </div>
            //   </div>
            // </div>
          }
        </div>
        <Sankey
          width={width}
          {...props}
        />
      </div>
    </div>
  ) : null;
}
